<template lang="pug">
.ResultMiniCalendar
  .body(:class="`is-padding-${this.firstDayPadding}`")
    .date(
      v-for="i in endOfMonthDay"
      :class="{ 'is-done': isCompleted(i), 'is-today': isToday(i) }"
    )
      .inner

</template>

<script>
import moment from 'moment'
// import * as _ from 'lodash'

export default {
  name: 'km-result-mini-calendar',
  components: {},
  props: {
    dates: {
      default: () => []
    }
  },
  data() {
    return {
      year: moment().year(),
      month: moment().month() + 1,
      endOfMonthDay: moment().endOf('month').date(),
      firstDayPadding: moment().startOf('month').day(),
      sampleDates: []
    }
  },
  computed: {},
  methods: {
    isToday(day) {
      const targetDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      return targetDate === moment().format('YYYY-MM-DD')
    },
    isCompleted(day) {
      const targetDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      return this.dates.findIndex(date => date === targetDate) !== -1
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.ResultCalendar {
}

.body {
  display: grid;
  margin: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
  background: #ccc;
  grid-template-rows: repeat(6, auto);
  grid-template-columns: repeat(7, 1fr);

  &.is-padding-0 .date:first-child { grid-column-start: 0; }
  &.is-padding-1 .date:first-child { grid-column-start: 1; }
  &.is-padding-2 .date:first-child { grid-column-start: 2; }
  &.is-padding-3 .date:first-child { grid-column-start: 3; }
  &.is-padding-4 .date:first-child { grid-column-start: 4; }
  &.is-padding-5 .date:first-child { grid-column-start: 5; }
  &.is-padding-6 .date:first-child { grid-column-start: 6; }


  .date {
    position: relative;
    width: 18px;
    height: 12px;
    border-right: 2px solid #ccc;
    border-bottom: 2px solid #ccc;
    background: #fff;
    font-size: 2rem;
    color: #000;
  }

  .date.is-today {
    .inner {
      height: 10px;
      border: 2px solid red;
    }
  }

  .date.is-done {
    background: orange;
  }
}

.debug {
  position: fixed;
  top: 0;
  left: 0;
  color: #fff;
}

</style>
